<template>
  <v-col style="max-width: 900px">
    <h1 class="primary--text">
      {{ $t('documentation.titles.operators.title') }}
    </h1>
    <h2 class="primary--text">
      {{ $t('documentation.texts.operators.create.subCreate') }}
    </h2>
    <p>{{ $t('documentation.texts.operators.create.paragraph1') }}</p>
    <v-img style="width: 100%; max-width: 900px" contain :src="pic1Name" />
    <p>{{ $t('documentation.texts.operators.create.paragraph2') }}</p>
    <p>{{ $t('documentation.texts.operators.create.paragraph2-1') }}</p>
    <v-img style="width: 100%; max-width: 900px" contain :src="pic2_1Name" />
    <p>{{ $t('documentation.texts.operators.create.paragraph3') }}</p>
    <p>{{ $t('documentation.texts.operators.create.paragraph4') }}</p>
    <v-img style="width: 100%; max-width: 900px" contain :src="pic2Name" />
    <v-img style="width: 100%; max-width: 900px" contain :src="pic3Name" />
    <p>{{ $t('documentation.texts.operators.create.paragraph5') }}</p>
    <p>{{ $t('documentation.texts.operators.create.paragraph6') }}</p>
    <v-img style="width: 100%; max-width: 900px" contain :src="pic4Name" />
  </v-col>
</template>

<script>
export default {
  computed: {
    pic1Name() {
      return require('@/assets/documentation/operators/' +
        this.$t('documentation.texts.operators.create.picCreate') +
        '.png')
    },
    pic2Name() {
      return require('@/assets/documentation/operators/' +
        this.$t('documentation.texts.operators.create.picPermissions') +
        '.png')
    },
    pic2_1Name() {
      return require('@/assets/documentation/operators/' +
        this.$t('documentation.texts.operators.create.picReceiveMails') +
        '.png')
    },
    pic3Name() {
      return require('@/assets/documentation/operators/' +
        this.$t('documentation.texts.operators.create.picSelectFilters') +
        '.png')
    },
    pic4Name() {
      return require('@/assets/documentation/operators/' +
        this.$t('documentation.texts.operators.create.picActivity') +
        '.png')
    },
  },
  methods: {},
}
</script>

<style>
.custom-link {
  transition: 0.3s;
  cursor: pointer;
}
.custom-link:hover {
  text-decoration: underline;
}
</style>
